import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { clientOne } from "../../store/client/actions";
export var useGetClientOne = function (trigger, clientId) {
    var dispatch = useDispatch();
    var validClientId = (clientId !== null && clientId !== void 0 ? clientId : "").trim();
    var _a = useSelector(function (state) {
        var _a;
        return ({
            loadingOneClient: state.Client.loadingOneClient,
            responseOneClient: (_a = state.Client.responseOneClient) === null || _a === void 0 ? void 0 : _a.data,
            errorOneClient: state.Client.errorOneClient,
        });
    }), loadingOneClient = _a.loadingOneClient, responseOneClient = _a.responseOneClient, errorOneClient = _a.errorOneClient;
    useEffect(function () {
        if (!trigger || !validClientId)
            return;
        dispatch(clientOne({
            clientId: clientId,
        }));
    }, [trigger, clientId]);
    return {
        responseOneClient: responseOneClient,
        errorOneClient: errorOneClient,
        loadingOneClient: loadingOneClient,
    };
};
